export enum TripStatus {
  COMPLETED = "COMPLETED",
  INCOMPLETE = "INCOMPLETE",
  CANCELLED = "CANCELLED",
}
